/* Kabla Vein Finder — Landing JS (corregido) */
(function () {
  function ready(fn) { 
    if (document.readyState !== 'loading') fn(); 
    else document.addEventListener('DOMContentLoaded', fn); 
  }

  function initKablaVeinFinder() {
    var root = document.querySelector('.kvf');
    if (!root) return;

    // Nav & Scroll
    var nav = root.querySelector('.kvf-nav');
    var heroInner = root.querySelector('.hero-inner');
    function onScroll() {
      var y = window.scrollY;
      if (nav) nav.classList.toggle('is-scrolled', y > 50);
      if (heroInner) {
        var t = Math.min(y / 600, 1);
        heroInner.style.transform = 'scale(' + (1 - t * 0.28) + ') translateY(' + (t * 40) + 'px)';
        heroInner.style.opacity = 1 - t * 0.7;
      }
    }
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Mobile Hamburger
    var hamburger = root.querySelector('.nav-hamburger');
    var mobileMenu = root.querySelector('.nav-mobile-menu');
    if (hamburger && mobileMenu) {
      hamburger.onclick = function () { mobileMenu.classList.toggle('is-open'); };
      mobileMenu.querySelectorAll('a').forEach(function (a) {
        a.onclick = function () { mobileMenu.classList.remove('is-open'); };
      });
    }

    // Intersection Observer
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('reveal-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      root.querySelectorAll('.reveal-io, .gallery-reveal-io, .p1-feature-card').forEach(function (el) { io.observe(el); });
    }

    // Before/After Slider
    var slider = root.querySelector('#before-after-slider');
    if (slider) {
      var beforeLayer = slider.querySelector('.before-layer');
      var handle = slider.querySelector('.slider-handle');
      var line = slider.querySelector('.slider-line');
      var dot = slider.querySelector('.slider-dot');
      function setPos(pct) {
        pct = Math.min(100, Math.max(0, pct));
        if (beforeLayer) beforeLayer.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        if (handle) handle.style.left = pct + '%';
        if (line) line.style.left = pct + '%';
        if (dot) dot.style.left = pct + '%';
      }
      function update(clientX) {
        var rect = slider.getBoundingClientRect();
        setPos(((clientX - rect.left) / rect.width) * 100);
      }
      function onMove(ev) { update(ev.clientX); }
      function onUp() {
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
      }
      if (handle) {
        handle.onpointerdown = function (e) {
          try { handle.setPointerCapture(e.pointerId); } catch (err) {}
          update(e.clientX);
          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', onUp);
        };
      }
      setPos(50);
    }

   // Product Gallery Thumbs
var thumbs = root.querySelectorAll('.thumb-btn');
var mainImg = root.querySelector('.gallery-main img');
thumbs.forEach(function (btn) {
  btn.onclick = function () {
    thumbs.forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    var src = btn.getAttribute('data-full');
    if (mainImg && src) mainImg.src = src;
  };
});

// Quantity Selector
var qtyVal = root.querySelector('[data-qty-val]');
var incBtn = root.querySelector('[data-qty-inc]');
var decBtn = root.querySelector('[data-qty-dec]');
function getQty() { return parseInt(qtyVal ? qtyVal.textContent : '1', 10) || 1; }
function setQty(n) { if (qtyVal) qtyVal.textContent = Math.max(1, n); }
if (incBtn) incBtn.onclick = function () { setQty(getQty() + 1); };
if (decBtn) decBtn.onclick = function () { setQty(getQty() - 1); };

// Función auxiliar para agregar y redirigir al checkout
function buyNowAndRedirect(urlDestination) {
  var addBtn = root.querySelector('[data-add-to-cart]');
  if (!addBtn) return;
  
  var variantId = addBtn.getAttribute('data-variant-id');
  var label = addBtn.querySelector('[data-btn-label]');
  
  if (!variantId) { 
    if (label) label.textContent = 'Configura el producto en el editor'; 
    return; 
  }
  
  addBtn.disabled = true;
  if (label) label.textContent = 'Procesando...';

  // Usamos cart/clear.js o simplemente agregamos y redireccionamos a /checkout
  var rootUrl = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
  
  fetch(rootUrl + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: getQty() }] })
  })
  .then(function (r) { return r.json(); })
  .then(function () {
    window.location.href = urlDestination || '/checkout';
  })
  .catch(function () {
    if (label) label.textContent = 'Error, intenta de nuevo';
    addBtn.disabled = false;
  });
}

// 1. Botón "Agregar al carrito" -> Checkout directo
var addBtn = root.querySelector('[data-add-to-cart]');
if (addBtn) {
  addBtn.onclick = function () {
    buyNowAndRedirect('/checkout');
  };
}

// 2. Enlace "Más opciones de pago" -> Checkout directo
var moreOptionsBtn = root.querySelector('[data-go-checkout]');
if (moreOptionsBtn) {
  moreOptionsBtn.onclick = function (e) {
    e.preventDefault();
    buyNowAndRedirect('/checkout');
  };
}

// 3. Botón PayPal -> Inicia Checkout Express
var paypalBtn = root.querySelector('[data-paypal-trigger]');
if (paypalBtn) {
  paypalBtn.onclick = function () {
    // Agrega el ítem y redirige directamente a la pasarela de PayPal en Checkout
    buyNowAndRedirect('/checkout?payment=paypal');
  };
}

    // Solutions Tabs
    var solBtns = root.querySelectorAll('.sol-btn');
    var solPhotoImg = root.querySelector('.sol-photo img');
    solBtns.forEach(function (btn) {
      btn.onclick = function () {
        solBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var img = btn.getAttribute('data-img');
        if (solPhotoImg && img) solPhotoImg.src = img;
      };
    });

    // Use Case Tabs
    var ucTabs = root.querySelectorAll('.usecase-tab');
    var ucChallenge = root.querySelector('[data-uc-challenge]');
    var ucSolution = root.querySelector('[data-uc-solution]');
    var ucImpact = root.querySelector('[data-uc-impact]');
    var ucFeatureImg = root.querySelector('.uc-feature img');
    var ucFeatureLabel = root.querySelector('[data-uc-label]');
    var ucIdx = 0;
    function applyUc(idx) {
      var tab = ucTabs[idx];
      if (!tab) return;
      ucIdx = idx;
      ucTabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      if (ucChallenge) ucChallenge.textContent = tab.getAttribute('data-challenge') || '';
      if (ucSolution) ucSolution.textContent = tab.getAttribute('data-solution') || '';
      if (ucImpact) ucImpact.textContent = tab.getAttribute('data-impact') || '';
      if (ucFeatureImg) ucFeatureImg.src = tab.getAttribute('data-img') || '';
      if (ucFeatureLabel) ucFeatureLabel.textContent = tab.textContent;
    }
    ucTabs.forEach(function (tab, idx) { tab.onclick = function () { applyUc(idx); }; });
    var ucPrev = root.querySelector('[data-uc-prev]');
    var ucNext = root.querySelector('[data-uc-next]');
    if (ucPrev) ucPrev.onclick = function () { applyUc(Math.max(0, ucIdx - 1)); };
    if (ucNext) ucNext.onclick = function () { applyUc(Math.min(ucTabs.length - 1, ucIdx + 1)); };

    // FAQ Accordion FIX
    var faqItems = root.querySelectorAll('.faq-item');
    faqItems.forEach(function (item) {
      var q = item.querySelector('.faq-q');
      var icon = item.querySelector('.faq-icon');
      if (!q) return;
      q.onclick = function (e) {
        e.preventDefault();
        var wasOpen = item.classList.contains('open');
        faqItems.forEach(function (i) { 
          i.classList.remove('open'); 
          var ic = i.querySelector('.faq-icon'); 
          if (ic) ic.textContent = '+'; 
        });
        if (!wasOpen) { 
          item.classList.add('open'); 
          if (icon) icon.textContent = '−'; 
        }
      };
    });

    // Scroll button
    var scrollBtn = root.querySelector('.scroll-down-btn');
    if (scrollBtn) scrollBtn.onclick = function () { window.scrollBy({ top: window.innerHeight, behavior: 'smooth' }); };

    // Hero Video AutoPlay Fix
    var heroVideo = root.querySelector('.hero-bg-video video') || root.querySelector('video.hero-bg-video');
    if (heroVideo) {
      heroVideo.muted = true;
      heroVideo.defaultMuted = true;
      var tryPlay = function () { heroVideo.play().catch(function () {}); };
      tryPlay();
      document.addEventListener('click', tryPlay, { once: true });
      document.addEventListener('touchstart', tryPlay, { once: true });
    }
  }

  ready(initKablaVeinFinder);

  // Soporte para edición en vivo dentro del Editor de Temas de Shopify
  document.addEventListener('shopify:section:load', initKablaVeinFinder);
  document.addEventListener('shopify:block:select', initKablaVeinFinder);
})();
